module.exports = __webpack_public_path__ + "static/media/dsr_trainer3.57ef95b1.svg";